<template>
  <div class="full-reduction-pop">
    <van-popup
      v-model="show"
      position="bottom"
      round
      safe-area-inset-bottom
      :close-on-popstate="true"
      :style="{ 'min-height': '30%', 'max-height': '62%' , 'overflow': 'auto'}"
      @close="onClose"
      closeable
      close-icon="cross"
    >
      <div class="titleName">赠券</div>
      <div class="content">
        <CouponCard
          v-bind="$attrs"
          :source="source"
        />

      </div>
    </van-popup>
  </div>
</template>

<script>
import CouponCard from '@/pages/payment/couponPop/couponCard.vue';

export default {
  components: { CouponCard },
  props: {

  },
  data() {
    return {
      show: true,
      source: 0, // 来源详情页
    };
  },
  mounted() {
  },
  methods: {
    onClose() {
      this.$emit('giveCouponClose');
    },

  },
};
</script>
<style scoped lang="scss">
.full-reduction-pop {
  .titleName {
    color: #333;
    font-weight: 600;
    font-size: 33px;
    line-height: 45px;
    text-align: center;
    margin-top: 25px;
  }
  .content {
    height: calc(100% - 100px);
    padding: 60px 36px;

    .left-arrow {
      width: 14px;
      margin-left: auto;
    }

    .full-reduction-card {
      display: flex;
      align-items: center;
      width: 100%;
      height: 100px;
      margin-bottom: 18px;
      padding: 0 33px;
      border-radius: 14px;
      box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.1);

      .tag-component {
        margin-right: 18px;
      }

      .card-item {
        padding-right: 20px;
        color: #333;
        font-weight: 400;
        font-size: 25px;
        line-height: 36px;
      }
    }
  }
}
::v-deep .van-icon-cross:before {
  color: #666;
}
</style>
